import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  setupDescription: {
    id: 'F3w388',
    defaultMessage: 'Select the stores that will receive inventory updates from ShipStation.',
    description: 'Description text explaining inventory sync store selection',
  },
});
